require('./home-mobile/modules/contato-dropdown');

document.addEventListener('DOMContentLoaded', () => {
    window.HomeContatoDropdown?.init();

    const root = document.getElementById('blog-listing-snap');
    if (!root) return;

    const sections = Array.from(root.querySelectorAll('.post-slide'));
    if (!sections.length) return;

    const total = sections.length;
    const postCount = sections.filter(
        (s) => s.id !== 'post-newsletter' && !s.hasAttribute('data-rodape'),
    ).length;
    const currNum = document.getElementById('currNum');
    const totalNum = document.getElementById('totalNum');
    const navCounter = document.getElementById('navCounter');
    const scrollHint = document.getElementById('scrollHint');
    const overlay = document.getElementById('indexOverlay');
    const openBtn = document.getElementById('openIndexPill');
    const closeBtn = document.getElementById('closeIndex');
    const searchInput = document.getElementById('indexSearch');
    const indexList = document.getElementById('indexList');
    const indexPill = openBtn;

    if (totalNum) totalNum.textContent = postCount.toString().padStart(2, '0');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let currentIndex = 0;
    let isScrolling = false;
    let scrollLockTimer = null;
    let lenis = null;

    if (typeof window.Lenis !== 'undefined' && !prefersReducedMotion) {
        try {
            lenis = new window.Lenis({
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
                smoothWheel: false,
                smoothTouch: false,
            });
            window.lenis = lenis;

            const raf = (time) => {
                lenis.raf(time);
                requestAnimationFrame(raf);
            };
            requestAnimationFrame(raf);
        } catch (e) {
            lenis = null;
        }
    }

    function updateActiveSlide(index) {
        sections.forEach((sec, i) => {
            sec.classList.toggle('is-active', i === index);
        });
    }

    function updateCounter(index) {
        const sec = sections[index];
        const isPostSlide =
            sec && sec.id !== 'post-newsletter' && !sec.hasAttribute('data-rodape');
        if (currNum && isPostSlide) {
            const label = (index + 1).toString().padStart(2, '0');
            if (typeof gsap !== 'undefined') {
                gsap.to(currNum, {
                    y: -15,
                    opacity: 0,
                    duration: 0.3,
                    ease: 'power2.in',
                    onComplete: () => {
                        currNum.textContent = label;
                        gsap.fromTo(
                            currNum,
                            { y: 15, opacity: 0 },
                            { y: 0, opacity: 1, duration: 0.6, ease: 'expo.out' },
                        );
                    },
                });
            } else {
                currNum.textContent = label;
            }
        }

        if (navCounter) navCounter.style.opacity = isPostSlide ? '1' : '0';
        if (scrollHint) scrollHint.classList.toggle('is-hidden', index >= total - 1);

        if (indexPill && window.matchMedia('(min-width: 992px)').matches) {
            indexPill.classList.toggle('is-visible', isPostSlide);
        }
    }

    function scrollToSection(index) {
        const clamped = Math.max(0, Math.min(total - 1, index));
        if (clamped === currentIndex && isScrolling) return;
        if (isScrolling) return;

        isScrolling = true;
        clearTimeout(scrollLockTimer);
        currentIndex = clamped;

        updateActiveSlide(currentIndex);
        updateCounter(currentIndex);

        const target = sections[currentIndex];
        if (lenis) {
            lenis.scrollTo(target, {
                duration: 1.2,
                force: true,
                lock: true,
                onComplete: () => {
                    clearTimeout(scrollLockTimer);
                    scrollLockTimer = setTimeout(() => {
                        isScrolling = false;
                    }, 200);
                },
            });
        } else {
            target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        }

        scrollLockTimer = setTimeout(() => {
            isScrolling = false;
        }, 1500);
    }

    window.blogScrollToSection = scrollToSection;

    let wheelAccumulator = 0;
    let wheelTimer = null;
    const WHEEL_THRESHOLD = 20;

    window.addEventListener(
        'wheel',
        (e) => {
            if (document.body.classList.contains('index-open')) return;

            e.preventDefault();

            if (isScrolling) {
                wheelAccumulator = 0;
                return;
            }
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;

            wheelAccumulator += e.deltaY;
            clearTimeout(wheelTimer);
            wheelTimer = setTimeout(() => {
                wheelAccumulator = 0;
            }, 150);

            if (Math.abs(wheelAccumulator) >= WHEEL_THRESHOLD) {
                const direction = wheelAccumulator > 0 ? 1 : -1;
                wheelAccumulator = 0;
                if (direction > 0 && currentIndex < total - 1) {
                    scrollToSection(currentIndex + 1);
                } else if (direction < 0 && currentIndex > 0) {
                    scrollToSection(currentIndex - 1);
                }
            }
        },
        { passive: false },
    );

    let touchStartY = 0;
    window.addEventListener(
        'touchstart',
        (e) => {
            if (e.target.closest('input, textarea, select, .index-overlay, .index-right')) return;
            touchStartY = e.touches[0].clientY;
        },
        { passive: false },
    );
    window.addEventListener(
        'touchmove',
        (e) => {
            if (document.body.classList.contains('index-open')) return;
            if (e.target.closest('input, textarea, select, .index-overlay, .index-right')) return;
            e.preventDefault();
        },
        { passive: false },
    );
    window.addEventListener(
        'touchend',
        (e) => {
            if (document.body.classList.contains('index-open')) return;
            if (e.target.closest('input, textarea, select, .index-overlay, .index-right')) return;
            if (isScrolling) return;

            const touchEndY = e.changedTouches[0]?.clientY ?? touchStartY;
            const deltaY = touchStartY - touchEndY;
            if (Math.abs(deltaY) < 50) return;

            if (deltaY > 0 && currentIndex < total - 1) {
                scrollToSection(currentIndex + 1);
            } else if (deltaY < 0 && currentIndex > 0) {
                scrollToSection(currentIndex - 1);
            }
        },
        { passive: false },
    );

    window.addEventListener('keydown', (e) => {
        if (document.body.classList.contains('index-open')) return;
        const ae = document.activeElement;
        if (ae && ['INPUT', 'TEXTAREA', 'SELECT'].includes(ae.tagName)) return;

        if (['ArrowDown', 'PageDown', 'Space'].includes(e.code)) {
            e.preventDefault();
            scrollToSection(currentIndex + 1);
        } else if (['ArrowUp', 'PageUp'].includes(e.code)) {
            e.preventDefault();
            scrollToSection(currentIndex - 1);
        } else if (e.code === 'Home') {
            e.preventDefault();
            scrollToSection(0);
        } else if (e.code === 'End') {
            e.preventDefault();
            scrollToSection(total - 1);
        }
    });

    function buildIndex(filter = '') {
        if (!indexList) return;
        const search = filter.toLowerCase().trim();
        indexList.innerHTML = '';
        let count = 0;
        const limit = 10;

        sections.forEach((sec, i) => {
            if (sec.id === 'post-newsletter' || sec.hasAttribute('data-rodape')) return;
            if (count >= limit) return;

            const titleEl = sec.querySelector('.post-title');
            const categoryEl = sec.querySelector('.category-tag');
            const ctaEl = sec.querySelector('.post-cta');
            if (!titleEl) return;

            const titleHTML = titleEl.innerHTML;
            const titleText = titleEl.innerText;
            const category = categoryEl ? categoryEl.innerText : '';
            const postUrl = ctaEl ? ctaEl.getAttribute('href') : '';

            if (
                search &&
                !titleText.toLowerCase().includes(search) &&
                !category.toLowerCase().includes(search)
            ) {
                return;
            }

            count += 1;
            const li = document.createElement('li');
            li.className = 'index-item';
            const link = document.createElement('a');
            link.className = 'index-link';
            link.dataset.index = i;
            link.href = postUrl || '#';
            link.innerHTML = `
                <span class="index-num">${(i + 1).toString().padStart(2, '0')}</span>
                <div class="index-text">
                    <div class="index-post-title">${titleHTML}</div>
                    <div class="index-post-category">${category}</div>
                </div>
            `;
            li.appendChild(link);
            indexList.appendChild(li);
        });
    }

    function openIndexOverlay() {
        if (!overlay) return;
        buildIndex(searchInput ? searchInput.value : '');
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('index-open');
        if (typeof gsap !== 'undefined') {
            gsap.from('.index-item', {
                opacity: 0,
                y: 20,
                stagger: 0.03,
                duration: 0.6,
                ease: 'power2.out',
                delay: 0.1,
            });
        }
    }

    function closeIndexOverlay() {
        if (!overlay) return;
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('index-open');
    }

    if (openBtn) openBtn.addEventListener('click', openIndexOverlay);
    if (closeBtn) closeBtn.addEventListener('click', closeIndexOverlay);
    if (searchInput) searchInput.addEventListener('input', () => buildIndex(searchInput.value));
    if (scrollHint) {
        scrollHint.addEventListener('click', () => {
            scrollToSection(currentIndex + 1);
        });
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('index-open')) {
            closeIndexOverlay();
        }
    });

    updateActiveSlide(0);
    if (currNum) currNum.textContent = '01';

    if (indexPill) {
        setTimeout(() => indexPill.classList.add('is-visible'), 600);
    }
});
